import _slicedToArray from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import React, { createContext, useContext, useEffect, useState } from 'react';
import isEqual from 'fast-deep-equal';
import isUndefined from 'lodash/isUndefined';

var filterSelector = function filterSelector(filter) {
  return function (f) {
    if (filter.identifier !== f.identifier) return false;
    if (!isUndefined(filter.min) && !isUndefined(filter.max) && filter.min === f.min && filter.max === f.max) return true;
    if (!isUndefined(filter.dateMin) && !isUndefined(filter.dateMax) && filter.dateMin === f.dateMin && filter.dateMax === f.dateMax) return true;
    if (filter.value && filter.level && filter.level === f.level && f.value === filter.value) return true;
    if (filter.value && filter.value === f.value) return true;
    return false;
  };
};

export var searchStateEqual = function searchStateEqual(a, b) {
  return isEqual(a, b);
};

var SearchkitClientState = /*#__PURE__*/function () {
  function SearchkitClientState() {
    _classCallCheck(this, SearchkitClientState);
  }

  _createClass(SearchkitClientState, [{
    key: "getSearchState",
    value: function getSearchState() {
      return this.searchState;
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      this.setSearchState(function (searchState) {
        return Object.assign(Object.assign({}, searchState), {
          query: query,
          filters: [],
          page: {
            from: 0,
            size: searchState.page.size
          }
        });
      });
    }
  }, {
    key: "resetPage",
    value: function resetPage() {
      this.setSearchState(function (searchState) {
        return Object.assign(Object.assign({}, searchState), {
          page: {
            from: 0,
            size: searchState.page.size
          }
        });
      });
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.setSearchState(function (searchState) {
        return Object.assign(Object.assign({}, searchState), {
          filters: []
        });
      });
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return this.searchState.query;
    }
  }, {
    key: "setPage",
    value: function setPage(page) {
      this.setSearchState(function (prevState) {
        return Object.assign(Object.assign({}, prevState), {
          page: page
        });
      });
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.searchState.filters;
    }
  }, {
    key: "canResetSearch",
    value: function canResetSearch() {
      return !(this.searchState.filters.length === 0 && !this.searchState.query);
    }
  }, {
    key: "isFilterSelected",
    value: function isFilterSelected(filter) {
      var foundFilter = this.searchState.filters.find(filterSelector(filter));
      return !!foundFilter;
    }
  }, {
    key: "getFiltersByIdentifier",
    value: function getFiltersByIdentifier(identifier) {
      var filters = this.searchState.filters.filter(function (filter) {
        return identifier === filter.identifier;
      });
      return filters.length > 0 ? filters : [];
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      this.setSearchState(function (prevState) {
        var filters = prevState.filters.reduce(function (filters, f) {
          if (filterSelector(filter)(f)) {
            return _toConsumableArray(filters);
          }

          return [].concat(_toConsumableArray(filters), [Object.assign({}, f)]);
        }, []);
        return Object.assign(Object.assign({}, prevState), {
          filters: filters
        });
      });
    }
  }, {
    key: "removeFiltersByIdentifier",
    value: function removeFiltersByIdentifier(identifier) {
      this.setSearchState(function (prevState) {
        var filters = prevState.filters.filter(function (f) {
          return f.identifier !== identifier;
        });
        return Object.assign(Object.assign({}, prevState), {
          filters: filters
        });
      });
    }
  }, {
    key: "addFilter",
    value: function addFilter(filter) {
      this.setSearchState(function (prevState) {
        var filters = [Object.assign({}, filter)].concat(_toConsumableArray(prevState.filters));
        return Object.assign(Object.assign({}, prevState), {
          filters: filters
        });
      });
    }
  }, {
    key: "toggleFilter",
    value: function toggleFilter(filter) {
      if (this.isFilterSelected(filter)) {
        this.removeFilter(filter);
      } else {
        this.addFilter(filter);
      }
    }
  }, {
    key: "setSortBy",
    value: function setSortBy(sortBy) {
      this.setSearchState(function (prevState) {
        return Object.assign(Object.assign({}, prevState), {
          sortBy: sortBy
        });
      });
    }
  }]);

  return SearchkitClientState;
}();

export function createSearchState(state) {
  var searchState = Object.assign({}, state);

  var setSearchState = function setSearchState(fn) {
    Object.assign(searchState, fn(searchState));
  };

  var scs = new SearchkitClientState();
  scs.setSearchState = setSearchState;
  scs.searchState = searchState;
  return scs;
}
export var SearchkitClient = /*#__PURE__*/function (_SearchkitClientState) {
  _inherits(SearchkitClient, _SearchkitClientState);

  function SearchkitClient() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        itemsPerPage = _ref.itemsPerPage;

    _classCallCheck(this, SearchkitClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchkitClient).call(this));
    _this.baseSearchState = {
      query: '',
      filters: [],
      page: {
        size: itemsPerPage || 10,
        from: 0
      },
      sortBy: ''
    };
    _this.onSearch = null;
    return _this;
  }

  _createClass(SearchkitClient, [{
    key: "updateBaseSearchState",
    value: function updateBaseSearchState(updates) {
      this.baseSearchState = Object.assign(Object.assign(Object.assign({}, this.baseSearchState), updates), {
        page: Object.assign(Object.assign({}, this.baseSearchState.page), updates.page)
      });
    }
  }, {
    key: "performSearch",
    value: function performSearch() {
      if (this.onSearch) this.onSearch(this.getSearchState());
    }
  }, {
    key: "setCallbackFn",
    value: function setCallbackFn(callback) {
      this.onSearch = callback;
    }
  }, {
    key: "search",
    value: function search() {
      this.performSearch();
    }
  }]);

  return SearchkitClient;
}(SearchkitClientState);
export var SearchkitContext = createContext({});
export var SearchkitVariablesContext = createContext({});
export var SearchkitRoutingOptionsContext = createContext(null);
export function SearchkitProvider(_ref2) {
  var client = _ref2.client,
      children = _ref2.children;
  var baseState = Object.assign({}, client.baseSearchState);

  var _useState = useState(baseState);

  var _useState2 = _slicedToArray(_useState, 2);

  client.searchState = _useState2[0];
  client.setSearchState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pendingSearch = _useState4[0],
      setPendingSearch = _useState4[1];

  var _useState5 = useState(baseState),
      _useState6 = _slicedToArray(_useState5, 2),
      searchVariables = _useState6[0],
      setSearchVariables = _useState6[1];

  client.setCallbackFn(function () {
    setPendingSearch(true);
  });
  useEffect(function () {
    if (pendingSearch) {
      setPendingSearch(false);
      setSearchVariables(client.searchState);
    }
  }, [pendingSearch]);
  return React.createElement(SearchkitContext.Provider, {
    value: client
  }, React.createElement(SearchkitVariablesContext.Provider, {
    value: searchVariables
  }, children));
}
export function useSearchkitVariables() {
  var variables = useContext(SearchkitVariablesContext);
  return variables;
}
export function useSearchkit() {
  var sk = useContext(SearchkitContext);
  return sk;
}
export function useSearchkitRoutingOptions() {
  return useContext(SearchkitRoutingOptionsContext);
}
export function useSearchkitQueryValue() {
  var api = useSearchkit();

  var _useState7 = useState(api.getQuery()),
      _useState8 = _slicedToArray(_useState7, 2),
      query = _useState8[0],
      setQuery = _useState8[1];

  useEffect(function () {
    setQuery(api.getQuery() || '');
  }, [api.searchState]);
  return [query, setQuery];
}
export function useSearchkitQuery(query) {
  console.error('useSearchkitQuery has now been removed. Use useSearchkitVariables hook + useQuery instead.');
}